import * as Sentry from "@sentry/browser";
import axios, { AxiosError, AxiosResponse } from "axios";
import STATUS_CODE from "enums/STATUS_CODE";
import usePersistStore from "hooks/useStore/usePersistStore";

const UNAUTHORIZED_STATUSES = [STATUS_CODE.UNAUTHORIZED, STATUS_CODE.FORBIDDEN];
export const LOGIN_PAGE = "/login";
const UNAUTHENTICATED_PAGES = [
  LOGIN_PAGE,
  "/share",
  "/j/",
  "/download-app",
  "/forgot-password",
  "/forgot-pin",
  "/reset-password",
];

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    if (config.skipAuth) {
      return config;
    }

    const { url = "" } = config;
    const isNotAuth = !url.split("/").includes("auth");
    const { token = null } = usePersistStore.getState();

    if (
      config.headers &&
      isNotAuth &&
      typeof token === "string" &&
      token.trim() !== ""
    ) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError): Promise<never> => {
    if (
      error.response?.status &&
      !UNAUTHORIZED_STATUSES.includes(error.response?.status)
    ) {
      Sentry.captureException(error);
    }
    return Promise.reject(error);
  },
);

// Add a response interceptor
axios.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    return response;
  },
  (error: AxiosError): Promise<never> => {
    const { response: { status = null } = { status: null } } = error || {
      response: { status: null },
    };

    if (
      status &&
      UNAUTHORIZED_STATUSES.includes(status) &&
      !UNAUTHENTICATED_PAGES.some((path) =>
        window.location.pathname.includes(path),
      )
    ) {
      window.location.href = `${LOGIN_PAGE}?redirect_url=${window.location.pathname}`;
    }

    return Promise.reject(error);
  },
);

export { axios };
